/*eslint-disable*/
'use strict';

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var assign = require('object-assign');
var velocity = require('velocity-animate');
var getClosest = require('./get-closest');
require('velocity-animate/velocity.ui');
var Modal = function () {
  /**
   *
   * @param config
   */
  function Modal() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Modal);
    this.config = assign({}, {
      // defaults
      triggerClass: 'lg-modal',
      transitionIn: 'transition.slideDownIn',
      transitionOut: 'transition.slideUpOut',
      transitionDuration: 500,
      allowCustomContent: false,
      customContent: '',
      openOnLoad: false,
      onLoadTarget: 'lgModal',
      clickOutsideToClose: true,
      onOpen: function onOpen() {},
      onClose: function onClose() {},
      afterOpen: function afterOpen() {},
      afterClose: function afterClose() {}
    }, config);
    var customContent = this.config.customContent;

    // create custom content element

    this._customContentWrapper = document.createElement('div');
    this._customContentWrapper.classList.add('custom-content');
    this._customContentWrapper.innerHTML = customContent;
  }

  /**
   * Bind Events for the Modal Class
   */

  _createClass(Modal, [{
    key: 'bindEvents',
    value: function bindEvents() {
      var _this = this;
      var _config = this.config,
        triggerClass = _config.triggerClass,
        openOnLoad = _config.openOnLoad;
      var _modal = Array.from(document.querySelectorAll('.' + triggerClass));
      _modal.forEach(function (el) {
        el.addEventListener('click', _this.openModal.bind(_this));
      });
      var _modalClose = Array.from(document.querySelectorAll('.modal__close'));
      _modalClose.forEach(function (el) {
        el.addEventListener('click', _this.closeModal.bind(_this));
      });
      if (openOnLoad) {
        this.openModal();
      }
    }

    /**
     *
     * @param e
     */
  }, {
    key: 'openModal',
    value: function openModal(e) {
      var _config2 = this.config,
        openOnLoad = _config2.openOnLoad,
        onLoadTarget = _config2.onLoadTarget;
      if (openOnLoad) {
        //get the target modal using the id
        this._targetModal = document.getElementById(onLoadTarget);
      } else {
        e.preventDefault();
        this._eventTarget = e.currentTarget;

        //get id from data attribute and remove # from the start of the string
        this._targetModalId = this._eventTarget.dataset.modal.slice(1);
        //get the target modal using the id
        this._targetModal = document.getElementById(this._targetModalId);
      }
      if (this._targetModal) {
        this.animateOpen();
      }
    }

    /**
     * Animates open target modal - used for both openModal() and open(target)
     */
  }, {
    key: 'animateOpen',
    value: function animateOpen() {
      var _this2 = this;
      var _config3 = this.config,
        transitionIn = _config3.transitionIn,
        transitionDuration = _config3.transitionDuration,
        onOpen = _config3.onOpen,
        afterOpen = _config3.afterOpen,
        clickOutsideToClose = _config3.clickOutsideToClose;

      //get the modal element that will be animated

      this._targetModalInner = this._targetModal.querySelector('.modal__inner');

      //set the scroll distance WHEN the modal is opened
      this._scrollDist = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);

      //Animate the modal to appear
      velocity(this._targetModalInner, transitionIn, {
        duration: transitionDuration,
        begin: function begin() {
          //if there are any transitions added to the body previously, remove them - bug with notifications
          document.body.style.removeProperty('transform');
          //set aria-hidden to false so that the modal displays
          _this2._targetModal.setAttribute('aria-hidden', false);
          _this2._targetModal.classList.remove('modal--closed');
          _this2._targetModal.classList.add('modal--opening');
          //insert content if it is allowed
          _this2.addContent();
          //trigger onOpen function
          onOpen();
        },
        complete: function complete() {
          //add open class to body so that it is positioned fixed and can't scroll
          document.body.classList.add('modal-open');
          _this2._targetModal.classList.remove('modal--opening');
          _this2._targetModal.classList.add('modal--open');
          //mimic the scroll position so it doesn't jump to the top of the page
          document.body.style.top = _this2._scrollDist * -1 + 'px';
          //trigger afterOpen function
          afterOpen();
          if (clickOutsideToClose) {
            _this2.clickOutside(_this2._targetModalInner);
          }
        },
        promiseRejectEmpty: false
      });
    }

    /**
     *
     */
  }, {
    key: 'closeModal',
    value: function closeModal(e) {
      e.preventDefault();
      this.animateClose();
    }

    /**
     * Animates closed target modal - used for both closeModal() and close(target)
     */
  }, {
    key: 'animateClose',
    value: function animateClose() {
      var _this3 = this;
      var _config4 = this.config,
        transitionOut = _config4.transitionOut,
        transitionDuration = _config4.transitionDuration,
        onClose = _config4.onClose,
        afterClose = _config4.afterClose;
      velocity(this._targetModalInner, transitionOut, {
        duration: transitionDuration,
        begin: function begin() {
          //trigger onClose function
          onClose();
          _this3._targetModal.classList.remove('modal--open');
          _this3._targetModal.classList.add('modal--closing');
        },
        complete: function complete() {
          //remove the open class from the body - makes it scrollable again
          document.body.classList.remove('modal-open');
          //set aria-hidden to true so that the modal hides
          _this3._targetModal.setAttribute('aria-hidden', true);
          _this3._targetModal.classList.remove('modal--closing');
          _this3._targetModal.classList.add('modal--closed');
          //set the scroll position to match that of when it was opened.
          document.body.scrollTop = _this3._scrollDist;
          document.documentElement.scrollTop = _this3._scrollDist;
          document.body.style.top = null;
          _this3.removeContent();
          //trigger afterClose function
          afterClose();
        },
        promiseRejectEmpty: false
      });
    }

    /**
     * Add custom content from options to a custom content modal
     */
  }, {
    key: 'addContent',
    value: function addContent() {
      var allowCustomContent = this.config.allowCustomContent;
      if (allowCustomContent) {
        var _modalContent = this._targetModalInner.querySelector('.modal__container');
        _modalContent.appendChild(this._customContentWrapper);
      }
    }

    /**
     * Removes content from a custom content modal
     */
  }, {
    key: 'removeContent',
    value: function removeContent() {
      var allowCustomContent = this.config.allowCustomContent;
      if (allowCustomContent) {
        this._customContentWrapper.parentNode.removeChild(this._customContentWrapper);
      }
    }

    /**
     *
     * @param element
     */
  }, {
    key: 'clickOutside',
    value: function clickOutside(element) {
      var _this4 = this;
      element.addEventListener('click', function (e) {
        var clicked = e.target;
        var closest = getClosest(clicked, '.modal__container');
        if (clicked.classList.contains('modal__container') || closest !== false) {
          return;
        } else {
          _this4.closeModal(e);
        }
      });
    }

    /**
     *
     * @returns Node
     */
  }, {
    key: 'getEventTarget',
    value: function getEventTarget() {
      return this._eventTarget || false;
    }

    //
    /**
     * Event that can be called to open a particular modal without using a trigger
     *
     * @param target
     */
  }, {
    key: 'open',
    value: function open(target) {
      //get id from data attribute and remove # from the start of the string
      var targetId = target.slice(1);
      //get the target modal using the id
      this._targetModal = document.getElementById(targetId);
      if (this._targetModal) {
        this.animateOpen();
      }
    }

    /**
     * Event that can be called to close a particular modal without using a trigger
     *
     * @param target
     */
  }, {
    key: 'close',
    value: function close(target) {
      //get id from data attribute and remove # from the start of the string
      var targetId = target.slice(1);
      //get the target modal using the id
      this._targetModal = document.getElementById(targetId);
      if (this._targetModal) {
        //get the modal element that will be animated
        var targetModalInner = this._targetModal.querySelector('.modal__inner');
        if (targetModalInner) {
          this._targetModalInner = targetModalInner;
          this.animateClose();
        }
      }
    }
  }]);
  return Modal;
}();
module.exports = Modal;